"use client";
import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import MyLink from "@/components/shared/myLink/MyLink";
import ExamCard from "@/components/shared/exams/ExamCard";

const LatestExams = ({ fullExams, loading }: any) => {
  return (
    <div className="w-full max-w-7xl mx-auto">
      <div className="mb-10 text-center">
        <h2 className="text-3xl md:text-4xl font-extrabold mb-4 text-white">
          أحدث الامتحانات الشاملة
        </h2>
        <p className="text-lg md:text-xl text-[#C7D0E0] max-w-2xl mx-auto">
          هنا تجد أحدث الامتحانات الشاملة التي تمت إضافتها حديثًا في المنصة.
        </p>
      </div>
      {loading ? (
        <SkeletonTheme baseColor="#474A4D" highlightColor="#6b6e72">
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 pb-10">
            {Array(3)
              .fill(0)
              .map((_, index) => (
                <div key={index} className="p-6 bg-[#323538] rounded-2xl">
                  <Skeleton height={180} className="w-full rounded-xl mb-4" />
                  <Skeleton height={20} width="70%" className="mb-2" />
                  <Skeleton height={20} width="90%" />
                  <Skeleton height={20} width="50%" className="mt-3" />
                  <Skeleton height={30} width="100%" className="mt-5" />
                </div>
              ))}
          </div>
        </SkeletonTheme>
      ) : fullExams && fullExams.length > 0 ? (
        <Carousel opts={{ direction: "rtl" }}>
          <CarouselContent className="pb-10">
            {[...fullExams].reverse().map((exam: any) => (
              <CarouselItem key={exam.id} className="md:basis-1/2 xl:basis-1/3">
                <ExamCard exam={exam} />
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="flex justify-center items-center gap-3 mt-4">
            <CarouselPrevious className="bg-primaryColor border-primaryColor hover:bg-primaryColor/80 text-white" />
            <MyLink
              href="/fullExams"
              className="bg-[#323538] text-16 text-white font-[500] py-2 px-8 rounded-lg border border-primaryColor hover:bg-primaryColor hover:text-white transition"
            >
              عرض الكل
            </MyLink>
            <CarouselNext className="bg-primaryColor border-primaryColor hover:bg-primaryColor/80 text-white" />
          </div>
        </Carousel>
      ) : (
        <div className="text-center text-red-400 bg-[#474A4D] rounded-lg py-6 px-4 mt-6">
          <p>لم يتم العثور على امتحانات.</p>
        </div>
      )}
    </div>
  );
};

export default LatestExams;
